import { TFunction } from 'i18next'

import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'
import { isDocumentTypeInvoice } from '@features/invoices/utils/isDocumentTypeInvoice'

import { NotificationKeys } from '../../../../../../../../../enums/notificationKeys'
import { DownloadFormatToMimeType } from '../../../../../../../constants/downloadFormatToMimeType'
import { fetchSalesOverviewReportInvoicesDownloadArchiveData } from '../../../../../../../query-api'
import { SalesReportSummary } from '../../../../../../../types/salesReportSummary'
import { DownloadWithProgress } from '../../../utils/downloadWithProgress'

// Estimated average weight of one compressed item from archive
const ESTIMATED_BYTES_PER_ITEM = 40960 // 40KB

interface DownloadSalesOverviewReportInvoicesArchiveProps {
  onError?: () => void
  onSuccess?: () => void
  salesOverviewReport: SalesReportSummary[]
  t: TFunction
}

export const downloadSalesOverviewReportInvoicesArchive = async ({
  onError,
  onSuccess,
  salesOverviewReport,
  t,
}: DownloadSalesOverviewReportInvoicesArchiveProps): Promise<void> => {
  const invoiceIds = salesOverviewReport
    .filter((item) => isDocumentTypeInvoice(item.documentType))
    .map((item) => item.id)
  const creditNoteIds = salesOverviewReport
    .filter((item) => isDocumentTypeCreditNote(item.documentType))
    .map((item) => item.id)

  const fetchExportData = () =>
    fetchSalesOverviewReportInvoicesDownloadArchiveData({
      invoiceIds,
      creditNoteIds,
    })

  const downloader = new DownloadWithProgress({
    bytesPerItem: ESTIMATED_BYTES_PER_ITEM,
    fetchExportData,
    itemCount: salesOverviewReport.length,
    mimeType: DownloadFormatToMimeType.zip,
    notificationId: NotificationKeys.SalesReportDownloadInvoices,
    onError,
    onSuccess,
    t,
  })

  await downloader.start()
}
